import { yellow1 } from 'app/components/ThemeProvider/colors';
import { SxProps } from '@mui/material';

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '12px 16px',
  background: 'transparent',
};
export const btnFilter: SxProps = {
  backgroundColor: 'white',
  width: 'fit-content',
  height: '48px',
  display: 'flex',
  gap: '10px',
  minWidth: '48px',
  p: '12px',
  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
  },
};

export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 48px',
  height: '75px',
};

export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '131px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
};
export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
};
